import React from 'react';
import DailyContent from '../components/DailyContent';
import TrackerTabs from '../components/TrackerTabs';
import DailyTasks from '../components/DailyTasks';
import InstructionGuide from '../components/InstructionGuide';

const HomePage: React.FC = () => {
  return (
    <div className="container mx-auto px-2 py-0 bg-[#f7f5e8]">
      <div className="max-w-4xl mx-auto">
        {/* Main content */}
        <div className="space-y-2">
          {/* Instruction Guide Button */}
          <div className="flex justify-end my-2">
            <InstructionGuide />
          </div>
          
          {/* Daily content (Ayat, Hadith) */}
          <DailyContent />
          
          {/* Track Tabs Component replacing the three columns */}
          <div className="mt-4">
            <TrackerTabs />
          </div>
          
          {/* Daily Tasks below tracker tabs */}
          <div className="mt-4">
            <DailyTasks />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
